import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://rlfnuytzxqzggarfgmum.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJsZm51eXR6eHF6Z2dhcmZnbXVtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5NDE4NDIsImV4cCI6MjA4OTUxNzg0Mn0.XDcUScYrAeSbYfiRZk7FOnDko4V0UBiuX7XrHkpqm1s'

export const supabase = createClient(supabaseUrl, supabaseKey)
